module.exports = __webpack_public_path__ + "assets/numbered_list.b5daba93.svg";